import { Select, styled } from '@mui/material';

const SmallSelect = styled(Select)(({ theme, fontColor }) => ({
    minWidth: 120,  // Adjust the width as needed
    height: 30,     // Adjust the height as needed
    fontSize: '0.875rem',  // Adjust the font size as needed
    '.MuiSvgIcon-root': {
        color: fontColor, // Change to your desired color
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: fontColor, // Change to your desired border color
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: fontColor, // Border color on hover
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: fontColor, // Border color when focused
    },
    color: fontColor
}));

export default SmallSelect;